import React, { useState, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import DashboardNavbar from './DashboardNavbar'
import DashboardSidebar from './DashboardSidebar'
import DashboardSidebarBelowXl from './DashboardSidebarBelowXl.jsx'

export default function DashboardLayout() {
  const [showMiniSidebar, setShowMiniSidebar] = useState(false)
  const location = useLocation()

  // Hide sidebar automatically on route change
  useEffect(() => {
    setShowMiniSidebar(false)
  }, [location.pathname])

  return (
   <main className='h-screen w-full flex flex-col relative bg-surface'>

    <nav className='h-16 w-full shrink-0 bg-surface'>
        <DashboardNavbar showMiniSidebar={showMiniSidebar} setShowMiniSidebar={setShowMiniSidebar} />
    </nav>

    <div className='flex w-full flex-1 overflow-hidden'>

        {/* left sidebar - same shade as navbar */}
        <aside className={`${showMiniSidebar ? 'w-24' : 'w-64'} h-full shrink-0 bg-surface transition-all duration-300 xl:block hidden`}>
            <DashboardSidebar showMiniSidebar={showMiniSidebar} />
        </aside>

        <aside className={`${showMiniSidebar ? ' md:w-24' : 'w-auto'} h-full shrink-0 bg-surface transition-all duration-300 xl:hidden block`}>
            <DashboardSidebarBelowXl showMiniSidebar={showMiniSidebar} setShowMiniSidebar={setShowMiniSidebar} />
        </aside>

        {/* main content - flex column, overflow-hidden so child gets fixed height for sticky footer */}
        <div className='flex-1 min-h-0 flex flex-col p-1 bg-[#f5f5f5] sm:p-3 md:rounded-2xl m-0 md:m-0 md:mr-2 md:mb-2 overflow-hidden'>
          <Outlet />
        </div>
   

        

    </div>

    {/* overlay for the sidebar below xl screen size - visible only when sidebar is open */}
    {showMiniSidebar ? (
        <div onClick={() => setShowMiniSidebar(false)} className="block xl:hidden fixed top-0 left-0 bottom-0 right-0 bg-black/50 z-[44]"></div>
    ) : null}
   </main>
  )
}
